import { register, init, locale, waitLocale } from 'svelte-i18n';
import { i18nStore } from '../stores/i18nStore';
import { getFromStorage } from '../utils/localStorage';
import type { Language } from '../stores/i18nStore';

/**
 * Initialize i18n system
 */
export async function initI18n() {
  // Register all locales
  register('de', () => import('./locales/de.json'));
  register('en', () => import('./locales/en.json'));
  register('fr', () => import('./locales/fr.json'));
  register('ja', () => import('./locales/ja.json'));
  register('es', () => import('./locales/es.json'));

  // Get initial language from localStorage or default to 'en'
  const storedLanguage = getFromStorage<Language>('language', 'en');
  const initialLocale = storedLanguage || 'en';

  // Initialize i18n
  await init({
    fallbackLocale: 'en',
    initialLocale: initialLocale,
  });

  // Wait for locale to be loaded
  await waitLocale(initialLocale);

  // Set initial locale
  locale.set(initialLocale);

  // Subscribe to language changes from store
  // This will also sync the current store value immediately
  i18nStore.subscribe(async (lang) => {
    if (lang && typeof window !== 'undefined') {
      try {
        await waitLocale(lang);
        locale.set(lang);
      } catch (error) {
        console.error('Failed to change locale:', error);
      }
    }
  });
}
